export const APP_IMAGE_BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1920
};
